import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-categorization-of-mutual-funds',
  templateUrl: './categorization-of-mutual-funds.component.html',
  styleUrls: [
    './categorization-of-mutual-funds.component.scss',
    './../ifacss.scss'
  ]
})
export class CategorizationOfMutualFundsComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    $(document).ready(function () {
      $(document).on('scroll', onScroll);

      //smoothscroll
      $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $(document).off('scroll');

        $('a').each(function () {
          $(this).parent('li').removeClass('active');
        });
        $(this).parent('li').addClass('active');

        var target = this.hash,
          menu = target;
        var $target = $(target);
        $('html, body')
          .stop()
          .animate(
            {
              scrollTop: $target.offset().top + 2
            },
            500,
            'swing',
            function () {
              window.location.hash = target;
              $(document).on('scroll', onScroll);
            }
          );
      });
    });
    var $calulatorComAccordian = $('.calculator_accordian');
    $calulatorComAccordian.on('show.bs.collapse', '.collapse', function () {
      $calulatorComAccordian.find('.collapse.in').collapse('hide');
    });
    $('[data-toggle="collapse"]').click(function () {
      $('.collapse.show').collapse('hide');
    });

    function onScroll(event) {
      var scrollPos = $(document).scrollTop();
      $('.lwptoc_items1 a').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr('href'));

        if (
          refElement.position().top <= scrollPos &&
          refElement.position().top + refElement.height() > scrollPos
        ) {
          $('.lwptoc_items1 ol li').removeClass('active');
          currLink.parent('li').addClass('active');
        } else {
          // currLink.parent('li').removeClass("active");
        }
      });
    }
  }
  modalPopOpen() {
    $('#LetsTalk_popup').modal('show');
  }
}
